import React from "react";
import { useTranslation } from "react-i18next";

import {
  Modal,
  Image,
  Button
} from '@lockerpm/design';

import {
  InfoCircleFilled
} from "@ant-design/icons";

import itemsComponents from "../../../components/items";
import images from "../../../assets/images";

const CreateMPConfirmModal = (props) => {
  const { DocLink } = itemsComponents;

  const {
    visible,
    callingAPI = false,
    onClose = () => { },
    onConfirm = () => { },
  } = props;

  const { t } = useTranslation();

  return (
    <Modal
      open={visible}
      width={480}
      title={
        <div className="flex items-center">
          <InfoCircleFilled className="text-warning" />
          <p className="ml-2">
            {t('create_master_password.confirm_nodal.title')}
          </p>
        </div>
      }
      closable={false}
      footer={false}
    >
      <div className="w-full text-center">
        <Image
          src={images.ImportantImg}
          height={120}
          width={120}
          preview={false}
        />
        <p className="text-center">
          {t('create_master_password.confirm_nodal.text1')}
        </p>
        <div className="text-center">
          {t('create_master_password.confirm_nodal.text2')}
          <DocLink
            className="!inline-flex ml-1"
            title={t('common.here')}
            showIcon={false}
            docKey="MASTER_PASSWORD"
          />
        </div>
        <div className="mt-4">
          <Button
            className="w-full"
            type="primary"
            loading={callingAPI}
            onClick={() => onConfirm()}
          >
            {t('create_master_password.confirm_nodal.btn_next')}
          </Button>
        </div>
        <div className="mt-2">
          <Button
            type="link"
            disabled={callingAPI}
            onClick={() => onClose()}
          >
            {t('create_master_password.confirm_nodal.btn_back')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CreateMPConfirmModal;